function getSanitizedJobTitle(input: string): string {
  return decodeURIComponent(input.toLowerCase())
    .replace(/[^a-z0-9\s]/gi, '')
    .trim();
}

export default getSanitizedJobTitle;
